import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import FeatherIcon from "feather-icons-react";
import {
    Table,
    Card,
    CardBody,
} from 'reactstrap';

import SortableThead from '../../../common/views/SortableThead';
import PosListItem from './PosListItem';

import { posApi, selectAllPos, setSorting, setFilters } from '../../reducers/posSlice';
import InputSearch from '../../../common/views/InputSearch';
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

import moment from 'moment-timezone';


const PosList = ({minCheckedAt, maxCheckedAt}) => {
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(false);

    const sorting = useSelector((state) => state.posReducer.sorting);
    const filters = useSelector((state) => state.posReducer.filters);
    const term = useSelector((state) => state.posReducer.term);
    const posList = useSelector((state) => selectAllPos(state));
    const showMore = useSelector((state) => state.posReducer.showMore );

    const [idSort] = useState(sorting.id);
    const [codeSort, setCodeSort] = useState(sorting.code);
    const [companyNameSort, setCompanyNameSort] = useState(sorting.company_name);
    const [signSort, setSignSort] = useState(sorting.sign);
    const [groupSort, setGroupSort] = useState(sorting.group);
    const [typeSort, setTypeSort] = useState(sorting.type);
    const [addressSort, setAddressSort] = useState(sorting.address);
    const [stateSort, setStateSort] = useState(sorting.state);
    const [avgScoreSort, setAvgScoreSort] = useState(sorting.avg_score);
    const [numChecksSort, setNumChecksSort] = useState(sorting.num_checks);
    const [latSurveyAtSort, setLastSurveyAt] = useState(sorting.last_survey_at);
    const [userFirstnameSort, setUserFirstnameSort] = useState(sorting.user_firstname);
    const [userLastnameSort, setUserLastnameSort] = useState(sorting.user_lastname);
    const [userEmailSort, setUserEmailSort] = useState(sorting.user_email);
    
    const [codeFilter, setCodeFilter] = useState(filters.code);
    const [companyNameFilter, setCompanyNameFilter] = useState(filters.company_name);
    const [signFilter, setSignFilter] = useState(filters.sign);
    const [groupFilter, setGroupFilter] = useState(filters.group);
    const [typeFilter, setTypeFilter] = useState(filters.type);
    const [addressFilter, setAddressFilter] = useState(filters.address);
    const [capFilter, setCapFilter] = useState(filters.cap);
    const [cityFilter, setCityFilter] = useState(filters.city);
    const [provinceFilter, setProvinceFilter] = useState(filters.province);
    const [stateFilter, setStateFilter] = useState(filters.state);
    const [minAvgScoreFilter, setMinAvgScoreFilter] = useState(filters.avg_score_min);
    const [maxAvgScoreFilter, setMaxAvgScoreFilter] = useState(filters.avg_score_max);
    const [minNumChecksFilter, setMinNumChecksFilter] = useState(filters.num_checks_min);
    const [maxNumChecksFilter, setMaxNumChecksFilter] = useState(filters.num_checks_max);
    const [minLastSurveyAt, setMinLastSurveyAt] = useState(filters.last_survey_at_min);
    const [maxLastSurveyAt, setMaxLastSurveyAt] = useState(filters.last_survey_at_max);
    // const [minCheckedAt, setMinCheckedAt] = useState(filters.checked_at_min);
    // const [maxCheckedAt, setMaxCheckedAt] = useState(filters.checked_at_max);
    const [userFirstnameFilter, setUserFirstnameFilter] = useState(filters.user_firstname);
    const [userLastnameFilter, setUserLastnameFilter] = useState(filters.user_lastname);
    const [userEmailFilter, setUserEmailFilter] = useState(filters.user_email);

    const dispatch = useDispatch();

    const loadMore = (p) => {
        if(!loading) {
            setLoading(true);

            let newSorting = {
                id: idSort,
                code: codeSort,
                company_name: companyNameSort,
                sign: signSort,
                group: groupSort,
                type: typeSort,
                address: addressSort,
                state: stateSort,
                avg_score: avgScoreSort,
                num_checks: numChecksSort,
                last_survey_at: latSurveyAtSort,
                user_firstname: userFirstnameSort,
                user_lastname: userLastnameSort,
                user_email: userEmailSort,
            }
            let newFilters = {
                code: codeFilter,
                company_name: companyNameFilter,
                sign: signFilter,
                group: groupFilter,
                type: typeFilter,
                address: addressFilter,
                cap: capFilter,
                city: cityFilter,
                province: provinceFilter,
                state: stateFilter,
                avg_score_min: minAvgScoreFilter ? parseFloat(minAvgScoreFilter) : null,
                avg_score_max: maxAvgScoreFilter ? parseFloat(maxAvgScoreFilter) : null,
                num_checks_min: minNumChecksFilter ? parseInt(minNumChecksFilter) : null,
                num_checks_max: maxNumChecksFilter ? parseInt(maxNumChecksFilter) : null,
                last_survey_at_min: minLastSurveyAt,
                last_survey_at_max: maxLastSurveyAt,
                checked_at_min: minCheckedAt ? minCheckedAt : null,
                checked_at_max: maxCheckedAt ? maxCheckedAt : null,
                user_firstname: userFirstnameFilter,
                user_lastname: userLastnameFilter,
                user_email: userEmailFilter,
            }

            dispatch(setSorting(newSorting));
            dispatch(setFilters(newFilters));
            dispatch(posApi.fetchAll( {page: p, term: term, sorting: newSorting, filters: newFilters} ));
        }
    }

    useEffect(() => {
        setPage(0);
        loadMore(0);
    }, [
        dispatch, term, 
        idSort, codeSort, companyNameSort, signSort, groupSort, typeSort, addressSort, 
        stateSort, avgScoreSort, numChecksSort, latSurveyAtSort, 
        userFirstnameSort, userLastnameSort, userEmailSort,
        codeFilter, companyNameFilter, signFilter, groupFilter, typeFilter, 
        addressFilter, capFilter, cityFilter, provinceFilter, stateFilter, 
        minAvgScoreFilter, maxAvgScoreFilter, minNumChecksFilter, maxNumChecksFilter, 
        minLastSurveyAt, maxLastSurveyAt, minCheckedAt, maxCheckedAt, 
        userFirstnameFilter, userLastnameFilter, userEmailFilter,
    ]);

    useEffect( () => {
        if(posList.length > 0 && showMore) setPage(page+1);
        setLoading(false);
    }, [posList])

    const formatDate = (dateString) => {
        let desiredFormat = "DD/MM/YYYY";
        let timeToBeConverted = moment(dateString);
        let timeZone = "Europe/Rome";

        return dateString ? timeToBeConverted.tz(timeZone).format(desiredFormat) : null;
    }

    return (
        <Card>
            <CardBody>
                <div style={{height: 'calc(100vh - 350px)', overflow: 'auto'}}>
                { 
                    // posList.length > 0
                    // ?   
                    <InfiniteScroll
                            element="div"
                            loadMore={ () => { loadMore(page); }}
                            hasMore={showMore}
                            loader={<div className="loader" key={0}>Loading ...</div>}
                            initialLoad={false}
                            useWindow={false}
                        >
                            <Table responsive hover style={{marginBottom: posList.length > 2 ? "" : "300px"}}>
                                <thead>
                                    <tr>
                                        {/* <SortableThead dir={idSort} onSortChange={(dir) => { setIdSort(dir) }}>Id</SortableThead> */}
                                        <SortableThead 
                                            style={{ width: "1%" }} dir={codeSort} onSortChange={(dir) => { setCodeSort(dir) }} 
                                            filter={ <InputSearch placeholder='code...' onChange={(value) => { setCodeFilter(value) }}  /> } 
                                        >Cod</SortableThead>
                                        <SortableThead 
                                            style={{ width: "15%" }} dir={companyNameSort} onSortChange={(dir) => { setCompanyNameSort(dir) }}
                                            filter={ <InputSearch placeholder='ragione sociale...' onChange={(value) => { setCompanyNameFilter(value) }}  /> } 
                                        >Ragione sociale</SortableThead>
                                        <SortableThead 
                                            style={{ width: "5%" }} dir={signSort} onSortChange={(dir) => { setSignSort(dir) }}
                                            filter={ <InputSearch placeholder='insegna...' onChange={(value) => { setSignFilter(value) }}  /> } 
                                        >Ins.</SortableThead>
                                        <SortableThead 
                                            style={{ width: "5%" }} dir={groupSort} onSortChange={(dir) => { setGroupSort(dir) }}
                                            filter={ <InputSearch placeholder='gruppo...' onChange={(value) => { setGroupFilter(value) }}  /> } 
                                        >Gruppo</SortableThead>
                                        <SortableThead 
                                            style={{ width: "5%" }} dir={typeSort} onSortChange={(dir) => { setTypeSort(dir) }}
                                            filter={ <InputSearch placeholder='tipo...' onChange={(value) => { setTypeFilter(value) }}  /> } 
                                        >Tipo</SortableThead>
                                        <SortableThead 
                                            style={{ width: "24%" }} dir={addressSort} onSortChange={(dir) => { setAddressSort(dir) }}
                                            filter={<>
                                                <InputSearch placeholder='indirizzo...' onChange={(value) => { setAddressFilter(value) }} /> 
                                                <InputSearch placeholder='cap...' onChange={(value) => { setCapFilter(value) }} /> 
                                                <InputSearch placeholder='città...' onChange={(value) => { setCityFilter(value) }} /> 
                                                <InputSearch placeholder='provincia...' onChange={(value) => { setProvinceFilter(value) }} /> 
                                            </>} 
                                        >Indirizzo</SortableThead>
                                        <SortableThead 
                                            style={{ width: "8%" }} dir={stateSort} onSortChange={(dir) => { setStateSort(dir) }}
                                            filter={ <InputSearch placeholder='regione...' onChange={(value) => { setStateFilter(value) }}  /> } 
                                        >Regione</SortableThead>
                                        <SortableThead 
                                            style={{ width: "8%" }} dir={userFirstnameSort} onSortChange={(dir) => { setUserFirstnameSort(dir); setUserLastnameSort(dir); setUserEmailSort(dir) }}
                                            filter={ <>
                                               <InputSearch placeholder='nome...' onChange={(value) => { setUserFirstnameFilter(value) }}  /> 
                                               <InputSearch placeholder='cognome...' onChange={(value) => { setUserLastnameFilter(value) }}  /> 
                                               <InputSearch placeholder='email...' onChange={(value) => { setUserEmailFilter(value) }}  /> 
                                            </>} 
                                        >Operatore</SortableThead>
                                        <SortableThead 
                                            style={{ width: "10%" }} dir={latSurveyAtSort} onSortChange={(dir) => { setLastSurveyAt(dir) }}
                                            filter={<>
                                                <Datetime
                                                    closeOnSelect={true}
                                                    dateFormat="DD/MM/YYYY"
                                                    timeFormat={false}
                                                    value={formatDate(minLastSurveyAt)}
                                                    inputProps={{ placeholder: "dal..." }}
                                                    onChange={(value) => {
                                                        setMinLastSurveyAt(value ? value.toISOString() : null)
                                                    }}
                                                />
                                                <Datetime
                                                    closeOnSelect={true}
                                                    dateFormat="DD/MM/YYYY"
                                                    timeFormat={false}
                                                    value={formatDate(maxLastSurveyAt)}
                                                    inputProps={{ placeholder: "al..." }}
                                                    onChange={(value) => {
                                                        setMaxLastSurveyAt(value ? value.toISOString() : null)
                                                    }}
                                                />
                                            </>} 
                                        >Ult. check</SortableThead>
                                        <SortableThead 
                                            style={{ width: "1%" }} dir={numChecksSort} onSortChange={(dir) => { setNumChecksSort(dir) }}
                                            filter={<>
                                                <InputSearch type="number" placeholder='>= di...' onChange={(value) => { setMinNumChecksFilter(value) }}  /> 
                                                <InputSearch type="number" placeholder='<= di...' onChange={(value) => { setMaxNumChecksFilter(value) }}  /> 
                                            </>} 
                                        >Check</SortableThead>
                                        <SortableThead 
                                            style={{ width: "1%" }} dir={avgScoreSort} onSortChange={(dir) => { setAvgScoreSort(dir) }}
                                            filter={ <>
                                                <InputSearch type="number" placeholder='>= di...' onChange={(value) => { setMinAvgScoreFilter(value) }}  /> 
                                                <InputSearch type="number" placeholder='<= di...' onChange={(value) => { setMaxAvgScoreFilter(value) }}  /> 
                                            </>} 
                                        >Pt.</SortableThead>
                                        <th style={{ width: "17%" }} ></th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    posList.length > 0 
                                    ?   posList.map((pos) => (
                                            <PosListItem pos={pos} key={pos.id} />
                                        ))
                                    : <tr>
                                        <td colSpan="12">
                                            <div className="d-flex h-100 p-4 flex-column align-items-center justify-content-center">
                                                <div className="pt-4"><FeatherIcon icon="grid" size="42" className="" /></div>
                                                <h4 className="mt-2">Please add new <b>point of sales</b>.</h4>
                                            </div>
                                        </td>
                                    </tr>
                                }
                                </tbody>
                            </Table>
                        </InfiniteScroll> 
                     
                }
                    
                </div>
            </CardBody>
        </Card>
    );
}

export default PosList;
